<template>
    <div class="body">
        <!-- 导航栏 -->
        <mslNav></mslNav>
        <!-- 标题 -->
        <div class="c_body">
            <div class="title ta_left">{{ detail.title }}</div>
            <div class="date ta_left">{{ detail.create_time || detail.update_time }}</div>
            <div class="article">
                <div class="txt ta_left" v-html="detail.content" v-if="detail.content"></div>
            </div>
            <div class="other">
                <div class="title ta_left left_center">
                    <div class="line"></div>
                    <div>相关内容</div>
                </div>
                <div class="list">
                    <template v-for="(item, index) in aboutList">
                        <div class="item" v-if="item.image_path" :key="index" @click="getAboutDetail(item.id)">
                            <div class="space_center ta_left" v-if="item.image_path">
                                <div class="left flex-box-1 r_position">
                                    <div class="i_title w m_ellipsis">{{ item.title }}</div>
                                    <div class="tab a_position b_0 l_0">{{ item.channel }}</div>
                                </div>
                                <div class="right flex-box-0">
                                    <img :src="item.image_path" alt="">
                                </div>
                            </div>
                        </div>
                        <div class="item" v-if="!item.image_path" :key="index" @click="getAboutDetail(item.id)">
                            <div class="top_a i_title w m_ellipsis">{{ item.title }}</div>
                            <div class="space_center bottom_box">
                                <div class="bottom_a tab">{{ item.channel }}</div>
                            </div>
                        </div>
                    </template>

                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import { newsDetail, newsList } from '../api/common.js'
    export default {
        name: "news_detail",
        data() {
            return {
                id: null,
                detail: {},
                aboutList: [] // 相关资讯列表
            }
        },
        mounted() {
            this.getParams()
        },
        methods: {
            getParams(){
                this.id = this.$route.query.id; // 取到路由带过来的参数
                this.getDetail();
                this.getAboutList();
                window.scrollTo(0, 0);//回到顶部
            },
            // 相关资讯
            getAboutList () {
                try {
                    newsList({
                        diyname: 'news',
                        filter_id: this.id,
                        page: 1,
                        limit: 5
                    }).then((res) => {
                        if (res.code == 1) {
                            if (res.data.list && res.data.list.length > 0) {
                                this.aboutList = res.data.list;
                            }
                        }
                    })
                } catch {
                    this.$message.error('获取数据失败，请刷新');
                }
            },
            // 文章详情
            getDetail() {
                try {
                    newsDetail({
                        id: this.id
                    }).then((res) => {
                        console.log(res);
                        if (res.code == 1) {
                            if (res.data && res.data.id) {
                                this.detail = res.data;
                            }
                        }
                    })
                } catch {
                    this.$message.error('获取数据失败，请刷新');
                }
            },

            // 相关资讯内进入详情；
            getAboutDetail (id) {
                this.id = id;
                this.getDetail();
                this.getAboutList();
                window.scrollTo(0, 0);//回到顶部

            }
        }
    }
</script>

<style scoped lang="scss">
    .c_body {
        padding: 0 16px;
        box-sizing: border-box;
        .title {
            font-size: 20px;
            font-family: PingFang SC;
            font-weight: bold;
            line-height: 24px;
            color: #333333;
            margin-top: 16px;
        }
        .date {
            margin-top: 6px;
            font-size: 12px;
            font-family: SF Pro Display;
            font-weight: 400;
            line-height: 14px;
            color: #BFBFBF;
        }
        .article {
            margin-top: 16px;
            .txt {
                font-size: 14px;
                font-family: PingFang SC;
                font-weight: 400;
                line-height: 21px;
                color: #8C8C8C;
                opacity: 1;
            }
        }
        .a_img_box {
            width: 100%;
            height: 156px;
            border-radius: 2px;
            overflow: hidden;
            margin-top: 12px;
            img {
                width: 100%;
                height: 100%;
            }
        }
        .other {
            margin-top: 56px;
            padding-bottom: 90px;
            .title {
                .line {
                    margin-right: 6px;
                    margin-top: 2px;
                    width: 4px;
                    height: 16px;
                    border-radius: 0px;
                    background-color: #262626;
                }
            }
            .list {
                width: 100%;
                margin-top: 12px;
                .item {
                    width: 100%;
                    padding: 12px 0;
                    box-sizing: border-box;
                    border-bottom: 1px solid #f2f2f4;
                    .left {
                        height: 58px;
                        .i_title {
                            width: 100%;
                            font-size: 14px;
                            color: #262626;

                        }
                        .tab {
                            font-size: 12px;
                            color: #cccccc;
                        }
                    }
                    .right {
                        margin-left: 10px;
                        img {
                            width: 70px;
                            height: 56px;
                            border-radius: 2px;
                        }
                    }
                    .top_a {
                        width: 100%;
                        font-size: 14px;
                        color: #262626;
                        text-align: left;
                    }

                    .bottom_a {
                        font-size: 12px;
                        color: #cccccc;
                    }
                    .bottom_box {
                        margin-top: 12px;
                    }
                }
            }
        }
    }

</style>
